/* istanbul ignore file */
import { Button, Card, Flex, Hide, getPaletteColor } from 'pcln-design-system'
import styled from 'styled-components'
import { getBoxShadowOpacity, getDynamicMargin } from './DepartureSummaryHelpers'

const SbsAlignColumn = styled(Flex)`
  position: relative;
`

const PriceColumn = styled(Flex)`
  flex-direction: column;
  width: 28%;
  align-items: center;
  justify-content: center;
`

const ChangeFlightText = styled(Button)`
  font-size: 12px;
  ${(props) => props.theme.mediaQueries.sm} {
    ::after {
      content: ' Flight';
    }
  }
`

/**
 * Note: AIR_LISTINGS_SELECTED_FLIGHT_REDESIGN
 *
 * There is no native support for DS shadow animation yet
 * The current animation takes in window.offSetY as scrollPosition
 * the box-shadow values resemble shadow.md
 */
/* istanbul ignore next */
const CardWrapper = styled(Card)`
  ${({ theme }) => theme.mediaQueries.lg} {
    box-shadow: none;
  }

  box-shadow: ${({ scrollPosition, isSticky }) =>
    isSticky &&
    `0 0 2px 0 rgba(0, 0, 0, ${getBoxShadowOpacity(scrollPosition, 0.2, 200)}),
   0 4px 2px -2px rgba(0, 0, 0, ${getBoxShadowOpacity(scrollPosition, 0.12, 200)}), 
   0 4px 8px -1px rgba(0, 0, 0, ${getBoxShadowOpacity(scrollPosition, 0.16, 200)})`};

  ${({ scrollPosition, isSticky }) =>
    isSticky &&
    `
   margin-left:${getDynamicMargin(scrollPosition, 16, 0.08)};
   margin-right: ${getDynamicMargin(scrollPosition, 16, 0.08)};
   `};

  ${(props) => props.theme.mediaQueries[2]} {
    margin-left: 0;
    margin-right: 0;
  }
`

const StyledButton = styled(Button)`
  font-size: 12px;
  font-weight: bold;
  padding-left: 8px;
`

/**
 * Note: AIR_LISTINGS_SELECTED_FLIGHT_REDESIGN
 *
 * 1. We apply custom media queries to address specific breakpoint corner-cases
 * 2. SCv5 is out of sync for button, therefore variation="white" doesn't work
 *    - we have to manually apply DS color (bg and hover)
 */
/* istanbul ignore next */
const StyledRedesignButton = styled(Button)`
  white-space: nowrap;
  &:hover {
    background-color: ${getPaletteColor('background.light')};
  }
`

const StyledHide = styled(Hide)`
  width: 28%;
  margin: auto;
  @media only screen and (max-width: 40em) {
    display: none;
  }
`

export {
  SbsAlignColumn,
  PriceColumn,
  ChangeFlightText,
  CardWrapper,
  StyledButton,
  StyledRedesignButton,
  StyledHide,
}
